export type AqFindDetail = { query: string };

/** The text in the find field was edited. */
export class AqQueryChangedEvent extends CustomEvent<AqFindDetail> {
  static readonly type = 'QueryChanged';

  constructor(detail: AqFindDetail) {
    super(AqQueryChangedEvent.type, {
      detail,
      bubbles: true,
      composed: true,
    });
  }
}

/** The close button was pressed, or Escape was pressed in the text field. */
export class AqCloseRequestedEvent extends CustomEvent<AqFindDetail> {
  static readonly type = 'CloseRequested';

  constructor(detail: AqFindDetail) {
    super(AqCloseRequestedEvent.type, {
      detail,
      bubbles: true,
      composed: true,
    });
  }
}
